import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  mutation SetExpertIsTyping($id: ID!, $value: Boolean!) {
    setExpertIsTyping(id: $id, value: $value) {
      id
      expertIsTyping
    }
  }
`);
